var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticStyle:{"padding-top":"50px"}},[_c('TelHeader',{staticStyle:{"width":"100%","height":"50px","top":"0","left":"0"}}),_c('telp-intv-user-card',{attrs:{"userProfile":_vm.userProfile,"telpSampleList":_vm.telpSampleList}}),_c('div',[_c('div',{staticClass:"row q-mb-md"},[_c('q-btn-toggle',{staticStyle:{"margin":"auto"},attrs:{"no-caps":"","rounded":"","dense":"","toggle-color":"primary","text-color":"grey-6","options":_vm.hangZhouCounties},model:{value:(_vm.county),callback:function ($$v) {_vm.county=$$v},expression:"county"}}),_c('q-btn-toggle',{staticClass:"q-mx-lg q-px-sm",staticStyle:{"margin":"auto"},attrs:{"toggle-color":"primary","flat":"","dense":"","text-color":"grey-6","size":"md","options":[
          {
            label: ("全部 (" + (_vm.telpSampleList.length) + ")"),
            value: 'all',
          },
          {
            label: ("未处理 (" + (_vm.noneSample.length) + ")"),
            value: 'noneSample',
          },
          {
            label: ("有效样本 (" + (_vm.checkedSample.length) + ")"),
            value: 'checkedSample',
          },
          {
            label: ("无效样本 (" + (_vm.invalidSample.length) + ")"),
            value: 'invalidSample',
          },
          {
            label: ("无法确认 (" + (_vm.uncheckedSample.length) + ")"),
            value: 'uncheckedSample',
          } ]},on:{"input":_vm.filterSample},model:{value:(_vm.filterIndex),callback:function ($$v) {_vm.filterIndex=$$v},expression:"filterIndex"}})],1),_c('q-virtual-scroll',{staticClass:"full-height q-ma-lg",staticStyle:{"max-height":"75vh","max-width":"1200px","margin":"auto"},attrs:{"items":_vm.currentSamples},scopedSlots:_vm._u([{key:"default",fn:function(ref){
        var item = ref.item;
        var index = ref.index;
return [(item.detail.tel)?_c('q-item',{key:index,attrs:{"dense":""}},[_c('telp-inv-sample-list',{attrs:{"sample":item}})],1):_vm._e()]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }